import { configure, createLocalStorage, type ErrorResponse } from "@everon-it/api-client";
import useAuthStore from "@store/auth";
import useGlobalModalStore from "@store/modal";

export type ErrorResponseType = {
    errorCode?: string;
    message: string;
    statusCode: number;
    isEveronHttpError?: boolean;
};

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || "https://passport.prod-everon.co.kr/realms/everon/protocol/openid-connect/auth?response_type=code&client_id=everon-contents-stg";

function getEnv() {
    const env = process.env.REACT_APP_ENV;
    if (env === "production") {
        return "prod";
    } else if (env === "development") {
        return "stg";
    }
    return "local";
}

/**
 * 세션 토큰 초기화 및 로그인 페이지로 이동
 */
export const onSessionTokenReset = () => {
    useAuthStore.setState({ userInfo: undefined });
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    useGlobalModalStore.getState().hideGlobalModal();

    window.location.href = LOGIN_URL;
};

/**
 * 토큰 만료 에러 모달
 */
const tokenError = () => {
    return useGlobalModalStore.getState().setGlobalModal({
        modalType: "OneButtonModal",
        modalProps: {
            title: "세션이 만료되었습니다.\n다시 로그인 해주세요.",
            onConfirm: () => {
                onSessionTokenReset();
            },
            handleClose: () => {
                onSessionTokenReset();
            },
        },
    });
};

/**
 * 권한 없음 에러 모달
 */
const unAuthorizedError = () => {
    return useGlobalModalStore.getState().setGlobalModal({
        modalType: "OneButtonModal",
        modalProps: {
            title: "권한이 없습니다.",
            onConfirm: () => {
                onSessionTokenReset();
            },
            handleClose: () => {
                onSessionTokenReset();
            },
        },
    });
};

/**
 * 토큰 에러 판별
 */
function isTokenError({ status, message }: ErrorResponse): boolean {
    // 401 Unauthorized
    if (status === 401) {
        return true;
    }

    // 400 + 토큰 관련 메시지
    if (status === 400 && message) {
        return message.includes("Token is not active") || message.includes("Refresh toked issued before the client session started") || message.includes("Invalid refresh token. Token client and authorized client don't match");
    }

    return false;
}

/**
 * 토큰 에러 핸들링
 */
function handleTokenError({ status, message }: ErrorResponse): void {
    if (status === 401 && message === "Unauthorized") {
        unAuthorizedError();
    } else {
        tokenError();
    }
}

export function initializeApiClient() {
    configure({
        env: getEnv(),
        storage: createLocalStorage("token", "refreshToken"),
        isTokenError,
        onTokenError: handleTokenError,
    });
}
